import React from 'react';
import { string } from 'prop-types';

const DisabledIcon = ({ fill = 'black' }) => {
  return (
    <svg
      data-test="disabledIcon"
      width="12"
      height="12"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM4.5 2.5V3.5H5.5V2.5H4.5ZM4.5 4.5V7.5H5.5V4.5H4.5ZM1 5C1 7.205 2.795 9 5 9C7.205 9 9 7.205 9 5C9 2.795 7.205 1 5 1C2.795 1 1 2.795 1 5Z"
        fill={fill}
      />
    </svg>
  );
};

DisabledIcon.propTypes = {
  fill: string,
};

export default DisabledIcon;